import { PeriodPickerProps } from '@touche-lts/panel-ui/dist/components/shared/period-picker'

export enum CustomersTableSortProps {
  DATE_END = 'dateEnd',
  DATE_START = 'dateStart',
  EMAIL = 'email',
  // NEWER PROPS
  PHONE_NUMBER = 'phoneNumber',
  DATE = 'date',
  DATE_OF_BIRTH = 'dateOfBirth',
  REGISTERED_DATE = 'registeredDate',
  GENDER = 'gender',
  // 
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  REVENUE_TODAY_MAX = 'revenueTodayMax',
  REVENUE_TODAY_MIN = 'revenueTodayMin',
  REVENUE_TOTAL_MAX = 'revenueTotalMax',
  REVENUE_TOTAL_MIN = 'revenueTotalMin',
  REVENUE_TOTAL = 'revenueTotal',
}

export enum GenderSelect {
  MALE = 'Male',
  FEMALE = 'Female',
}

export interface CustomersTableSearchProps {
  raitingsMin?: number,
  raitingsMax?: number,
  revenueTotalMin?: number,
  revenueTotalMax?: number,
  firstName?: string,
  lastName?: string,
  customer?: string,
  emailAddress?: string,
  date?: PeriodPickerProps['period'],
  dateOfBirth?: PeriodPickerProps['period'],
  registeredOn?: PeriodPickerProps['period'],
  gender?: GenderSelect,
  phoneNumber?: string,
  fullName?: string,
  orderStatus?: string,
  order?: string,
  orderDate?: PeriodPickerProps['period'],
  store?: string,
}

export enum CustomerOrderSortProps {
  CUSTOMER_ID = 'customerId',
  MAX_AMOUNT = 'maxAmount',
  MAX_DATE = 'maxDate',
  MIN_AMOUNT = 'minAmount',
  MIN_DATE = 'minDate',
  NUMBER = 'number',
  STATUS = 'status',
}


